export default "__VITE_ASSET___FpmSn7J__"